<template>
    <div id="app" >
        <!-- <keep-alive :include="keepAliveList">
            <router-view></router-view>
        </keep-alive> -->
        <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
        <!-- isMobile&& -->  
        <div class="openloads" @click.stop="openLog"  ></div>      
        <div :class="{'screen-container':true, 'sm-screen-container':productPlay}"  v-show="isWidthScreen&&isMobile" >
            <div class="keyinfo" :class="{'ismobile':true}">
                <div class="detail">
                    <template >
                        <div class="contents">
                            <div class="item backs nogap">
                                <default-image :src="require('@/assets/commonsoon.png')" :fit="'contain'" :iswidth="true"></default-image>
                                <p>{{$t('NewFunctionComingSoonWidthScreen')}}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
         <div :class="{'screen-container':true, 'md-screen-container':productPlay}" v-show="!(isWidthScreen&&isMobile)">
           <router-view/>
        </div>
    </div>
</template>

<script>
import Vconsole from 'vconsole';
export default {
    name: 'App',
    data(){
        return {
            isWidthScreen:false,
            isKeyword:false,
            jitime:0,
            countshu:0,
            isShowAn:WKConfig.isShowLog,
        }
    },
    computed:{
        isMobile() {
        　　let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        　　return flag;
        },
        productPlay(){
            return this.$store.state.app.productPlay
        }
    },
    created(){
           if (window.orientation == 90 || window.orientation == -90||(window.screen.width<=992&&(window.screen.width>window.screen.height))) {
               this.isWidthScreen=true
               //console.error('//横屏')
            
            } else {
                
                this.isWidthScreen=false
                 //console.error('//竖屏')
            }
    },
    mounted(){
        console.log("是否開啓調試",this.WKConfig.isShowLog)
       // window.addEventListener('resize',this.hengshuping, false);
      //e.preventDefault() --- 阻止默认事件
      //当一个手指放在屏幕上时，会触发touchstart事件。如果另一个手指又放在了屏幕上，则会先触发gesturestart事件，随后触发基于该手指的touchstart事件。
          document.addEventListener('gesturestart', function (e) {
                e.preventDefault();
            });

            //在单个元素上单击两次 --- dblclick
            document.addEventListener('dblclick', function (e) {
                e.preventDefault();
            });

            //一个手指放在屏幕上时，会触发touchstart事件
            document.addEventListener('touchstart', function (event) {
                if (event.touches.length > 1) {
                event.preventDefault();
                }
            });

            // 如果一个或两个手指在屏幕上滑动，将会触发gesturechange事件
            // 但只要有一个手指移开，则会触发gestureend事件，紧接着又会触发toucheend事件。
            var lastTouchEnd = 0;
            document.addEventListener('touchend', function (event) {
                var now = (new Date()).getTime();
                if (now - lastTouchEnd <= 300) {
                event.preventDefault();
                }
                lastTouchEnd = now;
            }, false);
            // //調試工具
            // this.$nextTick(()=>{
            //     let xkk=document.querySelector('#__vconsole')
            //     if(WKConfig.isShowNav){
            //         let heisgh=document.querySelector('.coHeader').offsetHeight
            //         document.querySelector('.openloads').style.top=heisgh+'px'
            //     }
                
            //     if(xkk){
            //         if(this.isShowAn){
            //         xkk.style.display="block"
            //         }else{
            //         xkk.style.display="none"
            //         }
            //     }else{
            //         if(this.isShowAn){
            //           new Vconsole();
            //         }
            //     }
            // });


            // document.addEventListener('fullscreenchange', () => {
            //     if (this.checkIsFullScreen()) {
            //         this.productPlay = true
            //         console.log("进入全屏");
            //     } else {
            //         console.log("退出全屏");
            //         this.productPlay = false
                   
            //     }
            // })


   
      

    },
    methods:{
        
        checkIsFullScreen() {
            var isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen;
            return isFullScreen == undefined ? false : isFullScreen;
        },
        openLog(){
            let nowss=this.$moment().unix()
            //判断是否显示
            if(this.isShowAn){
                this.isShowAn=false
                let xkk=document.querySelector('#__vconsole')
                if(xkk){
                xkk.style.display="none"
                }
                return false
            }
           console.log("點擊次數",this.countshu)
            if(this.countshu==5){
                let xkk=document.querySelector('#__vconsole')
                if(xkk){
                xkk.style.display="block"
                }else{
                new Vconsole()
                }
                this.jitime=0
                this.countshu=0
                this.isShowAn=true
            }else{
                if(!this.jitime){
                this.jitime=nowss
                this.countshu=1
                }else{
                if(nowss<(this.jitime+3)){
                    this.jitime=nowss
                    this.countshu++
                }else{
                    this.jitime=0
                    this.countshu=0
                }
                }
            }
            }
        // hengshuping() {
        //     if (window.orientation == 90 || window.orientation == -90||(window.screen.width<=992&&(window.screen.width>window.screen.height))) {
        //        this.isWidthScreen=true            
        //     } else {                
        //         this.isWidthScreen=false
        //     }
        // }
    }
}
</script>
<style scope lang="scss">
//調式器具
// div#__vconsole {
//     display: none;
// }
.openloads{
  position: fixed;
  bottom: 20px;
  right: 0;
  z-index: 9999;
  // pointer-events: none;
  width: 20px;
  height: 20px;
  background:transparent;
  padding-bottom: 4vw;
  padding-bottom: GoOrderProject(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
//橫屏的提示效果
.sm-screen-container{
.keyinfo{
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .detail{
        flex: 1;
        display: flex;
        flex-direction: column;
        width: 100%;
        .contents{
            display: flex;
            align-items: center;
            gap: 20px;
            flex-direction: row;
            justify-content: space-between;
            height: 70%;
            .item{
                height: 100%;
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 20px;
                &.nogap{
                    gap: 0;
                    width: 50%;
                }
                &.backs{
                    background: #F6F6F6;
                    border-radius: 20px;
                }
                /deep/ .el-image{
                    height: 50%;
                }
                /deep/ img{
                    max-width: 50%;
                    max-height: 100%;
                }
                p{
                    margin-top: 30px;
                    font-size: 30px;
                    font-weight: bold;
                    color: #B02949;
                    
                }
                .citem{
                    flex: 1;
                    width: 100%;
                    &.backs{
                        background: #F6F6F6;
                        border-radius: 20px;
                    }
                }
            }
        }
        .xcontents{
            display: flex;
            flex-direction: column;
            gap: 20px;
            flex: 1;
            padding-top: 20px;
            .item{
                width: 100%;
                flex: 1;
                &.backs{
                    background: #F6F6F6;
                    border-radius: 20px;
                }
            }
        }
    }
    &.ismobile{
        height: auto;
        overflow: inherit;
        .detail{
            .contents{
                height: auto;
                .item{
                    padding: 40px 0;
                    .el-image{
                        max-width: 30%;
                        height: auto;
                    }
                    p{
                        font-size: 18px;
                        padding: 0 15px;
                        line-height: 25px;
                    }
                }
            }
        }
    }
}
}



/*横屏*/
    @media screen and (min-aspect-ratio: 13/9){
    .sm-screen-container{
        @media screen and (max-width: 992px){
            display: flex!important;
        }
    }
        .md-screen-container{
            @media screen and (max-width: 992px){
            display:none!important;
            }
        }
        #app{
            @media screen and (max-width: 992px){
                min-height: auto!important;
                }
            }
    }
    
    
/*竖屏*/
@media screen and (max-aspect-ratio: 13/9){
    .sm-screen-container{
        @media screen and (max-width: 992px){
            display: none!important;
        }
    }
    
    .md-screen-container{
        @media screen and (max-width: 992px){
            display: block!important;
        }
    }
}
    

</style>
<style >


#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-size: 16px;
    overflow-wrap: anywhere;
    word-break: normal;
}
.el-loading-mask{
    z-index: 2;
}
@media screen and (max-width: 992px){
    body, html {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
    #app,.screen-container,.containter,.main_container {
      height: 100%;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex: 1;
    }
    .sm-screen-container{
           justify-content: center;
          align-items: center;
    }
    #app {
        font-size: 3.2vw;
        /* min-height:640px; */
    }
   
    .el-collapse-item__content {
        font-size:2.6vw
    }
    .el-message-box {
        font-size: 3.6vw;
        max-width: 80%;
    }
    .el-button {
       padding:2vw 2vw;
       font-weight: 100;
       font-size: 3.6vw!important;
       box-sizing: border-box;
       min-width: 15vw;
    }
    .el-input__inner {
        height: 8vw;
       line-height: 8vw;
       font-size: 3.6vw!important;
    }
    .el-form-item{
        width:85%;
        margin-bottom:2vh!important;
    }
    .el-input{
        font-size: 3.6vw!important;
        border-radius:5vw;
    }
    .el-form-item__content {
      line-height:normal!important;
    }
    .el-input .el-input__clear {
      font-size: 4vw;
      display: flex;
      align-items: center;
      width: 5vw;
    }
    .el-input__icon {
        height: 100%;
        width: 5vw;
    }
    .el-input__suffix {
        display: flex;
    }
    span.el-input__suffix-inner {
        display: flex;
        align-items: center;
    }
    .el-input__suffix-inner+.el-icon-circle-close {
        display: none;
    }
    
    
}
</style>



// WEBPACK FOOTER //
// src/App.vue